// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pictos-dropdown[data-v-781f479c] {\n  background: white !important;\n  border: 0;\n  -webkit-box-shadow: 0 2px 2px 1px rgba(0, 0, 0, 0.06);\n          box-shadow: 0 2px 2px 1px rgba(0, 0, 0, 0.06);\n}\n", ""]);
// Exports
module.exports = exports;
